export default {
  setDashboardInfo (state, data) {
    state.dashboard = data
  },
}
